<ph-card *ngIf="open" flat heading="What was wrong with this answer?">
    <ph-stack>
        <ph-toolbar>
            <ph-chip
                *ngFor="let chip of chips; trackBy: trackByChipId"
                size="small"
                [selected]="selectedChip === chip.id"
                (click)="onChipClick(chip.id)">
                {{ chip.label }}
            </ph-chip>
        </ph-toolbar>

        <ng-container *ngIf="showSendPanel">
            <ph-field>
                <ph-label [sub]="selectedChip !== 'other' ? '(optional)' : ''">Tell us a bit more</ph-label>
                <ph-textarea
                    [(ngModel)]="detailText"
                    ngDefaultControl
                    [placeholder]="currentDetailPlaceholder"
                    rows="3"></ph-textarea>
            </ph-field>
            <ph-actions>
                <ph-button variant="secondary" mode="filled" size="small" (click)="onSkipClick()">Skip</ph-button>
                <ph-button size="small" (click)="onSendClick()">Send feedback</ph-button>
            </ph-actions>
        </ng-container>
    </ph-stack>
</ph-card>
